import React, { ReactElement } from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { AdminPermissionsSystemValues, ApplicationPermissionsSystemValues } from '@fluentsms/types-fluent';
import { useAuth } from '../auth';

export type AuthorizedRouteProps = RouteProps & {
  redirectUrl: string;
  authorizationTarget: AdminPermissionsSystemValues | ApplicationPermissionsSystemValues;
  tenantOrgEntityId?: string;
  isApplicationPermissions?: boolean;
};

export const AuthorizedRoute = ({ ...props }: AuthorizedRouteProps): ReactElement => {
  const { authorizationTarget, redirectUrl, tenantOrgEntityId, isApplicationPermissions = false } = props;
  const { isAuthorized, hasAuthorizedAnywhere } = useAuth();
  const { pathname } = useLocation();

  if (isApplicationPermissions) {
    if (hasAuthorizedAnywhere(authorizationTarget)) {
      return <Route {...props} />;
    }
  }

  if (isAuthorized(authorizationTarget, tenantOrgEntityId)) {
    return <Route {...props} />;
  } else {
    return (
      <Redirect
        to={{
          pathname: `${redirectUrl}`,
          search: pathname !== '/' ? `?${new URLSearchParams({ from: pathname }).toString()}` : undefined,
        }}
      />
    );
  }
};

export default AuthorizedRoute;
